import type { IconProps } from './types';

export const PencilSquareIcon = (props: IconProps) => {
  const {
    size = 18,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g clip-path="url(#clip0_90_30)">
        <path
          d="M7.07143 2.57143H2.57143C1.86136 2.57143 1.28572 3.14707 1.28572 3.85714V15.4286C1.28572 16.1387 1.86136 16.7143 2.57143 16.7143H14.1429C14.853 16.7143 15.4286 16.1387 15.4286 15.4286V10.9286"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M9.63926 11.5232L5.78384 12.2143L6.4264 8.32353L13.1468 1.66429C13.2663 1.54434 13.4085 1.44912 13.5651 1.38415C13.7217 1.31917 13.8896 1.28571 14.0593 1.28571C14.2289 1.28571 14.3969 1.31917 14.5535 1.38415C14.7101 1.44912 14.8523 1.54434 14.9718 1.66429L16.334 3.02094C16.4544 3.13992 16.5501 3.28146 16.6153 3.43743C16.6805 3.59339 16.7142 3.76068 16.7142 3.92963C16.7142 4.09859 16.6805 4.26587 16.6153 4.42183C16.5501 4.5778 16.4544 4.71934 16.334 4.83832L9.63926 11.5232Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_90_30">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
